import { Tooltip } from "antd";

const BlockchainCard = ({ blockchain }) => {
  const {
    explorerUrl,
    rpcUrl,
    createdAt,
    updatedAt,
    chainId,
    name,
    symbol,
    nativeCurrency,
    priceInUsd,
    status,
    _id,
  } = blockchain;

  const infoH = [
    {
      title: "Explorer Url",
      value: explorerUrl,
      description:
        "A link to the blockchain explorer where you can view details about this smart contract or token.",
    },
    {
      title: "ID in DB",
      value: _id,
      description:
        "The unique identifier of the token in the internal database.",
    },
    {
      title: "RPC Url",
      value: rpcUrl,
      description:
        "The RPC (Remote Procedure Call) endpoint used to connect and interact with the blockchain network.",
    },
  ];

  const info = [
    {
      title: "Name",
      value: name,
      description:
        "The full name of the token used to identify the project or asset.",
    },
    {
      title: "Price in USD",
      value: priceInUsd,
      description:
        "The current market price of the token expressed in US dollars.",
    },
    {
      title: "Symbol",
      value: symbol,
      description:
        "The short symbol or ticker representing the token (e.g., BTC for Bitcoin).",
    },
    {
      title: "Native Currency",
      value: nativeCurrency,
      description:
        "The native currency of the blockchain on which the token operates (e.g., ETH for Ethereum).",
    },
    {
      title: "Chain ID",
      value: chainId,
      description:
        "A unique identifier for the blockchain network used when connecting via RPC.",
    },
    {
      title: "Status",
      value: status ? "Active" : "Disabled",
      description:
        "The current operational status of the token: active or disabled.",
    },
    {
      title: "Created at",
      value: new Date(createdAt).toLocaleString(),
      description:
        "The date and time when the token or its record was first created.",
    },
    {
      title: "Updated at",
      value: new Date(updatedAt).toLocaleString(),
      description:
        "The most recent date and time the token’s information was updated.",
    },
  ];

  return (
    <div>
      <div className="modaltitle">Information:</div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          width: "100%",
          padding: "20px 0",
          gap: "16px",
        }}
      >
        {info.map((el) => (
          <div
            key={el.title}
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              borderBottom: "1px solid gray",
              cursor: "pointer",
            }}
          >
            <Tooltip title={el.description} placement="bottom">
              <div style={{ fontSize: 10, color: "gray" }}>{el.title}:</div>
              <div style={{ fontSize: 16, color: "black" }}>{el.value}</div>
            </Tooltip>
          </div>
        ))}
      </div>
      <div
        style={{
          display: "flex",
          width: "100%",
          flexDirection: "column",
          paddingBottom: 20,
          gap: 16,
        }}
      >
        {infoH.map((el) => (
          <div
            key={el.title}
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              borderBottom: "1px solid gray",
              cursor: "pointer",
            }}
          >
            <Tooltip title={el.description} placement="bottom">
              <div style={{ fontSize: 10, color: "gray" }}>{el.title}:</div>
              <div style={{ fontSize: 16, color: "black" }}>{el.value}</div>
            </Tooltip>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BlockchainCard;
